import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { IonicPageModule } from "ionic-angular";
import { IonicModule } from "ionic-angular/module";
import { NavigationModule } from "../../../navigation/navigation.module";
import { DashboardPage } from "./dashboard";
import { PatientsListTableComponent } from "./patients-list-table/patients-list-table";
import { TaskDetailsRowComponent } from "./task-details-row/task-details-row";
import { TaskDetailsTableComponent } from "./task-details-table/task-details-table";

@NgModule({
  declarations: [
    DashboardPage,
    TaskDetailsTableComponent,
    PatientsListTableComponent,
    TaskDetailsRowComponent,
  ],
  imports: [
    IonicPageModule.forChild(DashboardPage),
    TranslateModule.forChild(),
    NavigationModule,
    CommonComponentsModule,
    IonicModule,
  ],
  entryComponents: [DashboardPage],
  exports: [DashboardPage],
})
export class DashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/common/dashboard/dashboard.module.ts